/**
 * Outlook Commands FunctionFile entrypoint.
 * Must be reachable at a stable URL and load Office.js.
 */
import React, { useEffect, useState } from 'react';

const OFFICE_JS_URL = 'https://appsforoffice.microsoft.com/lib/1/hosted/office.js';

const OfficeFunctionFileEntry: React.FC = () => {
    const [officeJsReady, setOfficeJsReady] = useState(
        typeof Office !== 'undefined'
    );

    useEffect(() => {
        if (typeof Office !== 'undefined') {
            setOfficeJsReady(true);
            return;
        }

        const existing = document.getElementById('office-js') as HTMLScriptElement | null;
        if (existing) {
            existing.addEventListener('load', () => setOfficeJsReady(true));
            return;
        }

        const script = document.createElement('script');
        script.id = 'office-js';
        script.src = OFFICE_JS_URL;
        script.async = true;
        script.onload = () => setOfficeJsReady(true);
        document.head.appendChild(script);
    }, []);

    useEffect(() => {
        if (!officeJsReady) return;
        try {
            Office.onReady(() => {
                // no-op: commands-only FunctionFile
            });
        } catch {
            // ignore
        }
    }, [officeJsReady]);

    return (
        <div style={{ display: 'none' }} aria-hidden="true" />
    );
};

export default OfficeFunctionFileEntry;

